import { render, staticRenderFns } from "./lastVisits.vue?vue&type=template&id=334c5d52"
import script from "./lastVisits.vue?vue&type=script&lang=js"
export * from "./lastVisits.vue?vue&type=script&lang=js"
import style0 from "./lastVisits.vue?vue&type=style&index=0&id=334c5d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports